import { defineQuery, defineQueryOptions } from '@pinia/colada'

export const AUTH_QUERY_KEYS = {
  token: ['auth', 'token'] as const,
}

export const authTokenQuery = defineQueryOptions({
  key: AUTH_QUERY_KEYS.token,
  async query() {
    const client = useRequestFetch()
    const { token } = await client<{ token: string | null }>('/api/get-token')
    return token
  },
  staleTime: 1000 * 60 * 60 * 24 - 60_000,
})

export const useAuthToken = defineQuery(authTokenQuery)
